import { FunctionalComponent, h } from '@stencil/core';
import { AppMedia, AppLink, AppLightbox } from './'
import get from 'lodash/get'
import state from '../store/store'

interface SectionLatestVideos {
    __component?: string;
    data?: any;
}


export const SectionLatestVideos: FunctionalComponent<SectionLatestVideos> = ({ data }) => {

    const { Autoplay, Infinite, Items = [], Title, Subtitle } = data;
    const BackgroundMuted = data.BackgroundMuted == null ? true : data.BackgroundMuted;
    const link = { Label: 'All Videos', URL: '/videos' }

    const getLightboxLink = (Media) => {
        return { Label: (get(state, 'website.VideosCTA') || 'Watch'), 'URL': get(Media, 'data.attributes.caption'), Icon: 'icon:play;ratio:1.1;' };
    }

    const isMobile = get(state.browser, 'mediaSize') == 's'

    return (
        Items.length > 0 &&
        <section class={`uk-section uk-position-relative ${BackgroundMuted ? 'uk-background-muted uk-container uk-container-xlarge' : 'uk-background-white'}`}>
            <div class="uk-container uk-margin-bottom uk-position-relative">
                <div class="uk-padding uk-padding-remove-top uk-padding-remove-left">
                    <h2 class="uk-heading-small wsio-gold uk-margin-small-bottom">{Subtitle}</h2>
                    <h3 class="uk-heading-xlarge wsio-darker-green uk-width-1-1 uk-margin-remove">{Title}</h3>
                    <AppLink className='uk-margin-top uk-button uk-button-text uk-text-muted' data={link} />
                </div>
            </div>
            <div class="uk-container uk-cover-container">
                <div uk-slideshow={`finite=${!Infinite};ratio: false; ${Autoplay ? 'autoplay: false;"' : ''}`}>
                    <div class="uk-position-relative" tabindex="-1" >
                        <ul class="uk-slideshow-items" style={isMobile ? { 'min-height': 'calc(100vh - 300px)' } : { 'min-height': 'calc(100vh - 250px)' }}>
                            {Items.map(({ Media, Subtitle, Title }) =>
                                <li>
                                    <div uk-lightbox="video-autoplay=1;" class='uk-link-reset uk-transition-toggle'>
                                        <AppLightbox className="wsio-link-hover" data={getLightboxLink(Media)}>
                                            <AppMedia className='wsio-sepia-image uk-transition-scale-up-hover uk-transition-opaque' size="(max-width: 638px) 80vh, (max-width: 958px) 80vw, 80vw" media={Media} cover />
                                            <div class="wsio-link-hover uk-width-1-6 uk-padding-small uk-text-center uk-position-bottom-left uk-position-center@s uk-light">
                                                <span uk-icon="icon:youtube; ratio:6;"></span>
                                            </div>
                                            <div class="uk-width-1-1 uk-width-3-5@m uk-position-bottom-right uk-padding-small uk-background-muted-light wsio-angle-left-large">
                                                <div class="uk-flex uk-flex-middle">
                                                    <div class="uk-width-1-1 uk-padding-small uk-position-relative">
                                                        <h4 class="uk-text-lead wsio-gold uk-margin-remove uk-text-truncate">{Subtitle}</h4>
                                                        <h5 class="uk-heading-small uk-margin-remove uk-text-truncate uk-text-muted">{Title}</h5>
                                                    </div>
                                                </div>
                                            </div>
                                        </AppLightbox>
                                    </div>
                                </li>
                            )}
                        </ul>
                    </div>
                    <ul class="uk-slideshow-nav uk-dotnav uk-flex-center uk-margin uk-margin-medium-top">
                    </ul>
                </div>
            </div>
        </section>
    )
};